export default "__VITE_ASSET__Ddk2nVPs__"